// extracted by mini-css-extract-plugin
module.exports = {"subheading":"hero-subheading_subheading__qyRw1"};